import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UtilsService } from '../services/utils.service';
import { ROUTES } from 'src/app/pages/routes';

/**
 * Prevents users from manually navigating to a step they haven't reached
 * or jumping back to a previous step by changing the URL directly.
 *
 * Strategy:
 * - Imperative navigation → allowed and stored
 * - User navigation → validated against stored route
 * - Exception: allow WebView العودة from Onfido (country_code)
 */
export const StepGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const utilsService = inject(UtilsService);

  const navigation = router.getCurrentNavigation();

  // 🔹 EXCEPCIÓN: retorno desde WebView (Onfido SDK de las APPS)
  const tree = router.parseUrl(state.url);
  const isVerifiData =
    tree.root.children['primary']?.segments[0]?.path === ROUTES.VERIFIDATA;
  const hasCountryCode = !!tree.queryParams['country_code'];

  if (isVerifiData && hasCountryCode) {
    utilsService.setAllowedRoute(state.url);
    return true;
  }

  // 🔹 Navegación iniciada por la app
  if (navigation?.trigger === 'imperative') {
    utilsService.setAllowedRoute(state.url);
    return true;
  }

  // 🔹 Navegación manual (back, forward, URL directa)
  const allowedRoute = utilsService.getAllowedRoute();

  if (!allowedRoute) {
    // Guards previos manejan redirección
    return true;
  }

  if (state.url === allowedRoute) {
    return true;
  }

  router.navigateByUrl(allowedRoute);
  return false;
};